import { ResponseError } from "./responseError";
/**
 * Created by stas on 5/22/2017.
 */

// Same as ApiJsonResult
export class BaseResponse<T> {

    Success: boolean;
    ResponseCode: number;
    Errors: Array<ResponseError>;
    Data: T;

    constructor(success: boolean, responseCode: number, errors: Array<ResponseError>, data: T) {
        this.Success = success;
        this.ResponseCode = responseCode;
        this.Data = data;
        this.Errors = errors;
    }

}


// WEBPACK FOOTER //
// ./app/objects/common/baseResponse.ts